import type { NodeDesignsRevision } from "../../schemas/index.ts";
import { anyReservedActions } from "./shared.ts";

export const getRedoRevision = (revisions: NodeDesignsRevision[]) => {
  if (revisions.length === 0 || !revisions[revisions.length - 1].skip) return undefined;

  if (anyReservedActions(revisions)) return undefined;

  const lastUnskippedIndex = revisions.findLastIndex((r) => !r.skip);
  if (lastUnskippedIndex === revisions.length - 1) return undefined;
  return revisions[lastUnskippedIndex + 1];
};

export const getRedoRevisionNo = (revisions: NodeDesignsRevision[]) => getRedoRevision(revisions)?.revision;
